module.exports = __webpack_public_path__ + "img/B12.dc189e1a.svg";